"use strict";

var _interopRequireWildcard3 = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _interopRequireWildcard2 = _interopRequireDefault(require("@babel/runtime/helpers/interopRequireWildcard"));

var _react = _interopRequireWildcard3(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _core = require("@material-ui/core");

var _customProps = require("../../../../../../utils/customProps");

var _Storyblok = _interopRequireDefault(require("../../../../../../utils/Storyblok"));

var _customComponents = require("../../../../../../utils/customComponents");

/* istanbul ignore next */
var ButtonRedirect = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return (0, _interopRequireWildcard2.default)(require("../../../../../../components/PageGrid/molecules/ButtonRedirect/ButtonRedirect"));
  });
});
var ButtonDownload = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return (0, _interopRequireWildcard2.default)(require("../../../../../../components/PageGrid/molecules/ButtonDownload/ButtonDownload"));
  });
});
var IconButtonRedirect = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return (0, _interopRequireWildcard2.default)(require("../../../../../../components/PageGrid/molecules/IconButtonRedirect/IconButtonRedirect"));
  });
});
var IconButtonDownload = /*#__PURE__*/(0, _react.lazy)(function () {
  return Promise.resolve().then(function () {
    return (0, _interopRequireWildcard2.default)(require("../../../../../../components/PageGrid/molecules/IconButtonDownload/IconButtonDownload"));
  });
});
var components = {
  ButtonRedirect: ButtonRedirect,
  ButtonDownload: ButtonDownload,
  IconButtonRedirect: IconButtonRedirect,
  IconButtonDownload: IconButtonDownload
};

var DialogActions = function DialogActions(_ref) {
  var content = _ref.content,
      rootClass = _ref.rootClass,
      disableSpacing = _ref.disableSpacing,
      storyblokClass = _ref.storyblokClass,
      dataBlokC = _ref.dataBlokC,
      dataBlokUid = _ref.dataBlokUid;

  var styles = _Storyblok.default.arrayToMuiStyles(rootClass);

  return /*#__PURE__*/_react.default.createElement(_core.DialogActions, {
    disableSpacing: disableSpacing,
    className: "".concat(styles.root, " ").concat(storyblokClass),
    "data-blok-c": dataBlokC,
    "data-blok-uid": dataBlokUid
  }, content.map(function (component, key) {
    return /*#__PURE__*/_react.default.createElement(_react.Suspense, {
      fallback: /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null)
    }, (0, _customComponents.renderComponentsWithBridge)(components, component, key));
  }));
};

var _default = DialogActions;
exports.default = _default;
DialogActions.propTypes = {
  /** stroyblok multiselect of css classes */
  rootClass: _propTypes.default.arrayOf(_propTypes.default.string),

  /**
    'ButtonRedirect',
    */
  content: function content(props, propName, componentName) {
    var comps = ['ButtonRedirect'];
    return (0, _customProps.validComponents)(props, propName, componentName, comps);
  },
  disableSpacing: _propTypes.default.bool,

  /** storyblok prop for when in editor to allow click bridge */
  dataBlokC: _propTypes.default.string,

  /** storyblok prop for when in editor to allow click bridge */
  dataBlokUid: _propTypes.default.string,

  /** storyblok prop for when in editor to allow click bridge */
  storyblokClass: _propTypes.default.string
};
DialogActions.defaultProps = {
  rootClass: [],
  content: [],
  disableSpacing: false,
  dataBlokC: '',
  dataBlokUid: '',
  storyblokClass: ''
};